import {
  fireYouVersionImpressionEvent
} from "./chunk-OJBEZFB2.mjs";
import {
  ContentIds
} from "./chunk-6XYU3377.mjs";
import {
  __async,
  __objRest,
  __spreadValues
} from "./chunk-WNQUEZJF.mjs";

// src/events/impression-event/impression.ts
import { State } from "@youversion/analytics-core";
var Impression = {
  App: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { applicationId } = _a, rest = __objRest(_a, ["applicationId"]);
      fireYouVersionImpressionEvent(__spreadValues(__spreadValues({ contentType: "app" }, ContentIds.App({ applicationId })), rest), options);
    })
  },
  AudioBible: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { audioBibleVersionId } = _a, rest = __objRest(_a, ["audioBibleVersionId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "audio_bible"
        }, ContentIds.AudioBible({ audioBibleVersionId })), rest),
        options
      );
    })
  },
  AudioBibleReference: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { audioBibleVersionId, usfm } = _a, rest = __objRest(_a, ["audioBibleVersionId", "usfm"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "audio_bible_reference"
        }, ContentIds.AudioBibleReference({ audioBibleVersionId, usfm })), rest),
        options
      );
    })
  },
  Auth: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { authType, userId } = _a, rest = __objRest(_a, ["authType", "userId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({ contentType: "auth" }, ContentIds.Auth({ authType, userId })), rest),
        options
      );
    })
  },
  Bible: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { bibleVersionId } = _a, rest = __objRest(_a, ["bibleVersionId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({ contentType: "bible" }, ContentIds.Bible({ bibleVersionId })), rest),
        options
      );
    })
  },
  BibleReference: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { bibleVersionId, usfm } = _a, rest = __objRest(_a, ["bibleVersionId", "usfm"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "bible_reference"
        }, ContentIds.BibleReference({ bibleVersionId, usfm })), rest),
        options
      );
    })
  },
  CommentaryAnnotation: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { annotationId } = _a, rest = __objRest(_a, ["annotationId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "commentary_annotation"
        }, ContentIds.CommentaryAnnotation({ annotationId })), rest),
        options
      );
    })
  },
  CommentaryKeyword: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { keywordId } = _a, rest = __objRest(_a, ["keywordId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "commentary_keyword"
        }, ContentIds.CommentaryKeyword({ keywordId })), rest),
        options
      );
    })
  },
  ContentPlaylist: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { playlistId, playlistType } = _a, rest = __objRest(_a, ["playlistId", "playlistType"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "content_playlist"
        }, ContentIds.ContentPlaylist({ playlistId, playlistType })), rest),
        options
      );
    })
  },
  ContentPlaylistItem: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { externalId, index, playlistId, playlistType } = _a, rest = __objRest(_a, ["externalId", "index", "playlistId", "playlistType"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "content_playlist_item"
        }, ContentIds.ContentPlaylistItem({ externalId, index, playlistId, playlistType })), rest),
        options
      );
    })
  },
  Friendship: {
    fire: (params, options) => __async(void 0, null, function* () {
      const rest = __objRest(params, []);
      fireYouVersionImpressionEvent(__spreadValues(__spreadValues({ contentType: "friendship" }, ContentIds.Friendship({})), rest), options);
    })
  },
  Gift: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { currency, frequency, fund, paymentMethod } = _a, rest = __objRest(_a, ["currency", "frequency", "fund", "paymentMethod"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "gift"
        }, ContentIds.Gift({ currency, frequency, fund, paymentMethod })), rest),
        options
      );
    })
  },
  Guide: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { languageTag, readingPlanId, subscriptionId } = _a, rest = __objRest(_a, ["languageTag", "readingPlanId", "subscriptionId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "guide"
        }, ContentIds.Guide({ languageTag, readingPlanId, subscriptionId })), rest),
        options
      );
    })
  },
  GuideDay: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { languageTag, readingPlanDay, readingPlanId, subscriptionId } = _a, rest = __objRest(_a, ["languageTag", "readingPlanDay", "readingPlanId", "subscriptionId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "guide_day"
        }, ContentIds.GuideDay({ languageTag, readingPlanDay, readingPlanId, subscriptionId })), rest),
        options
      );
    })
  },
  GuidedPrayer: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { dayId, guideId } = _a, rest = __objRest(_a, ["dayId", "guideId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "guided_prayer"
        }, ContentIds.GuidedPrayer({ dayId, guideId })), rest),
        options
      );
    })
  },
  GuidedPrayerBackgroundAudio: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { audioCategoryId, dayId, guideId } = _a, rest = __objRest(_a, ["audioCategoryId", "dayId", "guideId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "guided_prayer_background_audio"
        }, ContentIds.GuidedPrayerBackgroundAudio({ audioCategoryId, dayId, guideId })), rest),
        options
      );
    })
  },
  GuidedPrayerModule: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { dayId, index, moduleId, type } = _a, rest = __objRest(_a, ["dayId", "index", "moduleId", "type"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "guided_prayer_module"
        }, ContentIds.GuidedPrayerModule({ dayId, index, moduleId, type })), rest),
        options
      );
    })
  },
  LocalVerseImage: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { bibleVersionId, imageId, languageTag, usfm } = _a, rest = __objRest(_a, ["bibleVersionId", "imageId", "languageTag", "usfm"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "local_verse_image"
        }, ContentIds.LocalVerseImage({ bibleVersionId, imageId, languageTag, usfm })), rest),
        options
      );
    })
  },
  Moment: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { momentId } = _a, rest = __objRest(_a, ["momentId"]);
      fireYouVersionImpressionEvent(__spreadValues(__spreadValues({ contentType: "moment" }, ContentIds.Moment({ momentId })), rest), options);
    })
  },
  None: {
    fire: (params, options) => __async(void 0, null, function* () {
      const rest = __objRest(params, []);
      fireYouVersionImpressionEvent(__spreadValues(__spreadValues({ contentType: "none" }, ContentIds.None({})), rest), options);
    })
  },
  NonIdleSegment: {
    fire: (params, options) => __async(void 0, null, function* () {
      const rest = __objRest(params, []);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({ contentType: "non_idle_segment" }, ContentIds.NonIdleSegment({})), rest),
        options
      );
    })
  },
  Organization: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { languageTag, organizationId } = _a, rest = __objRest(_a, ["languageTag", "organizationId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "organization"
        }, ContentIds.Organization({ languageTag, organizationId })), rest),
        options
      );
    })
  },
  Page: {
    fire: (params, options) => __async(void 0, null, function* () {
      var _a;
      const rest = __objRest(params, []);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "page",
          elementId: (_a = State.get("templatedPathname")) != null ? _a : location.pathname
        }, ContentIds.Page({})), rest),
        options
      );
    })
  },
  Plan: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { languageTag, readingPlanId, subscriptionId } = _a, rest = __objRest(_a, ["languageTag", "readingPlanId", "subscriptionId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "plan"
        }, ContentIds.Plan({ languageTag, readingPlanId, subscriptionId })), rest),
        options
      );
    })
  },
  PlanDay: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { languageTag, readingPlanDay, readingPlanId, subscriptionId } = _a, rest = __objRest(_a, ["languageTag", "readingPlanDay", "readingPlanId", "subscriptionId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "plan_day"
        }, ContentIds.PlanDay({ languageTag, readingPlanDay, readingPlanId, subscriptionId })), rest),
        options
      );
    })
  },
  PlanDevotionalAudio: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { languageTag, readingPlanDay, readingPlanId, subscriptionId } = _a, rest = __objRest(_a, ["languageTag", "readingPlanDay", "readingPlanId", "subscriptionId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "plan_devotional_audio"
        }, ContentIds.PlanDevotionalAudio({ languageTag, readingPlanDay, readingPlanId, subscriptionId })), rest),
        options
      );
    })
  },
  Prayer: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { prayerId } = _a, rest = __objRest(_a, ["prayerId"]);
      fireYouVersionImpressionEvent(__spreadValues(__spreadValues({ contentType: "prayer" }, ContentIds.Prayer({ prayerId })), rest), options);
    })
  },
  RelatedContentBibleReference: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { bibleVersionId, referenceLevel, usfm } = _a, rest = __objRest(_a, ["bibleVersionId", "referenceLevel", "usfm"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "related_content_bible_reference"
        }, ContentIds.RelatedContentBibleReference({ bibleVersionId, referenceLevel, usfm })), rest),
        options
      );
    })
  },
  Search: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { searchQuery } = _a, rest = __objRest(_a, ["searchQuery"]);
      fireYouVersionImpressionEvent(__spreadValues(__spreadValues({ contentType: "search" }, ContentIds.Search({ searchQuery })), rest), options);
    })
  },
  Story: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { lessonId } = _a, rest = __objRest(_a, ["lessonId"]);
      fireYouVersionImpressionEvent(__spreadValues(__spreadValues({ contentType: "story" }, ContentIds.Story({ lessonId })), rest), options);
    })
  },
  StoryActivity: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { activityType, storyId } = _a, rest = __objRest(_a, ["activityType", "storyId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "story_activity"
        }, ContentIds.StoryActivity({ activityType, storyId })), rest),
        options
      );
    })
  },
  StoryModule: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { lessonId, moduleId } = _a, rest = __objRest(_a, ["lessonId", "moduleId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "story_module"
        }, ContentIds.StoryModule({ lessonId, moduleId })), rest),
        options
      );
    })
  },
  StoryQuestion: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { questionId, storyId } = _a, rest = __objRest(_a, ["questionId", "storyId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "story_question"
        }, ContentIds.StoryQuestion({ questionId, storyId })), rest),
        options
      );
    })
  },
  StoryQuestionAnswer: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { answerId, questionId, storyId } = _a, rest = __objRest(_a, ["answerId", "questionId", "storyId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "story_question_answer"
        }, ContentIds.StoryQuestionAnswer({ answerId, questionId, storyId })), rest),
        options
      );
    })
  },
  StoryScene: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { sceneIndex, storyId } = _a, rest = __objRest(_a, ["sceneIndex", "storyId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "story_scene"
        }, ContentIds.StoryScene({ sceneIndex, storyId })), rest),
        options
      );
    })
  },
  User: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { userId } = _a, rest = __objRest(_a, ["userId"]);
      fireYouVersionImpressionEvent(__spreadValues(__spreadValues({ contentType: "user" }, ContentIds.User({ userId })), rest), options);
    })
  },
  VerseImage: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { bibleVersionId, imageId, languageTag, usfm } = _a, rest = __objRest(_a, ["bibleVersionId", "imageId", "languageTag", "usfm"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "verse_image"
        }, ContentIds.VerseImage({ bibleVersionId, imageId, languageTag, usfm })), rest),
        options
      );
    })
  },
  VerseMemorization: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { bibleVersionId, usfm } = _a, rest = __objRest(_a, ["bibleVersionId", "usfm"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "verse_memorization"
        }, ContentIds.VerseMemorization({ bibleVersionId, usfm })), rest),
        options
      );
    })
  },
  Video: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { languageTag, videoId } = _a, rest = __objRest(_a, ["languageTag", "videoId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({ contentType: "video" }, ContentIds.Video({ languageTag, videoId })), rest),
        options
      );
    })
  },
  VideoCollection: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { languageTag, videoCollectionId } = _a, rest = __objRest(_a, ["languageTag", "videoCollectionId"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "video_collection"
        }, ContentIds.VideoCollection({ languageTag, videoCollectionId })), rest),
        options
      );
    })
  },
  VOTD: {
    fire: (params, options) => __async(void 0, null, function* () {
      const _a = params, { bibleVersionId, date, usfm } = _a, rest = __objRest(_a, ["bibleVersionId", "date", "usfm"]);
      fireYouVersionImpressionEvent(
        __spreadValues(__spreadValues({
          contentType: "votd"
        }, ContentIds.VOTD({ bibleVersionId, date, usfm })), rest),
        options
      );
    })
  }
};

export {
  Impression
};
